import { render, staticRenderFns } from "./SingleColumnLayout.vue?vue&type=template&id=87c38666&"
import script from "./SingleColumnLayout.vue?vue&type=script&lang=js&"
export * from "./SingleColumnLayout.vue?vue&type=script&lang=js&"
import style0 from "./SingleColumnLayout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {
  VContainer,
})
